import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';
import { getInitials } from 'helpers';

import Cookies from 'universal-cookie';

const cookies = new Cookies();

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  let school = cookies.get('school')
  let isAlumni = cookies.get('isAlumni')
  let profilePicture = cookies.get('profilePicture')
  let status = (cookies.get('isAlumni') === "true") ? 'Alumni':'Student'

  const user = {
    name: 'Hello, '+ cookies.get('firstName'),
    bio: school + ' ' + status,
    fullName: cookies.get('firstName') + ' ' + cookies.get('lastName')
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        className={classes.avatar}
        src={profilePicture}
      >

      </Avatar>
      <Typography
        className={classes.name}
        variant="h4"
      >
        {user.name}
      </Typography>
      <Typography variant="body2">{user.bio}</Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
